import {
  buildAuthCustomLoginFormMessages,
  buildAuthPasswordRequirementLabels,
  type CustomLoginFormMessages,
  type PasswordRequirementLabels,
} from "@assetwatch/auth";
import type { ReleaseInfoLabels } from "@assetwatch/ui";
import type { TFunction } from "i18next";

export function buildEnterprisePasswordRequirementLabels(
  t: TFunction,
): PasswordRequirementLabels {
  return buildAuthPasswordRequirementLabels(t, "enterprise");
}

export function buildEnterpriseCustomLoginFormMessages(
  t: TFunction,
): CustomLoginFormMessages {
  return buildAuthCustomLoginFormMessages(t, {
    commonNamespace: "enterprise.common",
    namespace: "enterprise",
  });
}

export function buildEnterpriseReleaseInfoLabels(
  t: TFunction,
): ReleaseInfoLabels {
  return {
    loadingReleaseInfo: t("enterprise.chrome.releaseInfo.loadingReleaseInfo"),
    copyRecord: t("enterprise.chrome.releaseInfo.copyRecord"),
    openSsm: t("enterprise.chrome.releaseInfo.openSsm"),
    openSsmAriaLabel: t("enterprise.chrome.releaseInfo.openSsmAriaLabel"),
    recordUnavailable: t("enterprise.chrome.releaseInfo.recordUnavailable"),
    copyPrefix: t("enterprise.chrome.releaseInfo.copyPrefix"),
    rows: {
      tag: t("enterprise.chrome.releaseInfo.rows.tag"),
      status: t("enterprise.chrome.releaseInfo.rows.status"),
      sha: t("enterprise.chrome.releaseInfo.rows.sha"),
      requestedRef: t("enterprise.chrome.releaseInfo.rows.requestedRef"),
      deployedAt: t("enterprise.chrome.releaseInfo.rows.deployedAt"),
      ssmParameter: t("enterprise.chrome.releaseInfo.rows.ssmParameter"),
      selected: t("enterprise.chrome.releaseInfo.rows.selected"),
      deployed: t("enterprise.chrome.releaseInfo.rows.deployed"),
      failed: t("enterprise.chrome.releaseInfo.rows.failed"),
      terraform: t("enterprise.chrome.releaseInfo.rows.terraform"),
      api: t("enterprise.chrome.releaseInfo.rows.api"),
      frontend: t("enterprise.chrome.releaseInfo.rows.frontend"),
    },
    links: {
      githubTag: t("enterprise.chrome.releaseInfo.links.githubTag"),
      githubCommit: t("enterprise.chrome.releaseInfo.links.githubCommit"),
      workflowRun: t("enterprise.chrome.releaseInfo.links.workflowRun"),
    },
    status: {
      complete: t("enterprise.chrome.releaseInfo.status.complete"),
      partial: t("enterprise.chrome.releaseInfo.status.partial"),
      failed: t("enterprise.chrome.releaseInfo.status.failed"),
      unknown: t("enterprise.chrome.releaseInfo.status.unknown"),
    },
    values: {
      unknown: t("enterprise.chrome.releaseInfo.values.unknown"),
      none: t("enterprise.chrome.releaseInfo.values.none"),
      notSelected: t("enterprise.chrome.releaseInfo.values.notSelected"),
      deployed: t("enterprise.chrome.releaseInfo.values.deployed"),
    },
  };
}
